module.exports = __webpack_public_path__ + "static/media/visa.6d8b3685.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/visa.png
// module id = 1982
// module chunks = 0